module.exports = __webpack_public_path__ + "img/logo.515d06ec.png";